import { Component, Input, ComponentFactoryResolver, ViewChild, OnInit, ElementRef, Inject, AfterViewInit } from '@angular/core';
import { LayoutMenu } from '../../../common/model/layout-menu';
import { DefaultValuesService } from '../../../modules/common/service/default-values.service';
import { deepCopy } from '../../../modules/common/utils/deepCopy';
//import { LayoutMenu } from '../../../common/model/layout-menu';
import { environment } from "../../../../environments/environment";
import { PermissoesUsuario } from '../../../modules/common/model/permissoes-usuario';
import { LayoutSubMenu } from '../../../common/model/layout-submenu';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { AccordionNavDirective } from './accordion-nav.directive';
import { AppendSubmenuIconDirective } from './append-submenu-icon.directive';
import { HighlightActiveItemsDirective } from './highlight-active-items.directive';

@Component({
	selector: 'my-app-sidenav-menu',
	styles: [],
	templateUrl: './sidenav-menu.component.html',
	standalone: true,
	imports: [
		CommonModule,
		RouterModule,
		MatIconModule,
		TranslatePipe,
		FormsModule,
		AccordionNavDirective,
		AppendSubmenuIconDirective,
		HighlightActiveItemsDirective
	],
	providers: [
		{ provide: DefaultValuesService, useClass: DefaultValuesService }
	]
})

export class AppSidenavMenuComponent implements OnInit, AfterViewInit {
	public AppConfig: any;

	menus: Array<LayoutMenu> = [];
	menusCompleto: Array<LayoutMenu> = [];
	filtro: string = '';

	constructor(private elRef: ElementRef, private defaultValuesService: DefaultValuesService) {
		this.AppConfig = environment;
	}
	ngAfterViewInit(): void {
	
	}


	ngOnInit() {

		this.defaultValuesService.obterMenu().then(m => {

			this.menusCompleto = Array<LayoutMenu>();
			let permissoesRecursos = PermissoesUsuario.recursos;

			m.forEach((m: LayoutMenu) => {
				if (permissoesRecursos.find(l => l.acao == m.recursoAcao && m.recurso.some(s => s == l.modulo))) {

					if (m.hasSubMenu) {
						let subMenu = Array<LayoutSubMenu>();
						m.subMenus.forEach((s: LayoutSubMenu) => {
							if (permissoesRecursos.find(l => l.acao == s.recursoAcao && s.recurso.some(s => s == l.modulo)))
								subMenu.push(s);
						});
						m.subMenus = subMenu;
					}

					this.menusCompleto.push(m);
				}
			});

			this.adicionarMenus();
		});
	}

	adicionarMenus() {
		this.menus = [];
		this.menus = this.menus.concat(this.menusCompleto);
	}

	applyFilter(filter: any): any {
		if (!filter || filter.length < 1) {
			this.adicionarMenus();
		} else {
			const filterValue = filter.toString().toLowerCase().trim();
			let copy: Array<LayoutMenu> = deepCopy(this.menusCompleto);

			this.menus = copy.filter(item => {
				if (item.subMenus != null && item.subMenus.length > 0) {
					item.subMenus = item.subMenus.filter(submenu => {
						return (submenu.nome.toString().toLowerCase().indexOf(filterValue) !== -1);
					});
				}
				return ((item.nome.toString().toLowerCase().indexOf(filterValue) !== -1) ||
					(item.subMenus != null && item.subMenus.length > 0));
			});

			setTimeout(() => { this.expandirAll(); }, 400);
		}
	}

	clearFilter() {
		this.filtro = '';
		this.applyFilter(this.filtro);
	}

	expandirAll() {
		const target = this.elRef.nativeElement.querySelector('.nav');

		for (const children of target.children) {
			if (children.className.toString().includes("hasSubMenu")) {
				children.click();
				return;
			}
		}
	}

	activeNav(rota: string) {
		return window.document.location.pathname === rota;
	}

	getSubmenuAnchorId(subMenu: LayoutSubMenu): string | null {
		switch (subMenu?.rota) {
			case '/app/tarefa':
				return 'ExecucaoEstrategia';
			case '/app/rotina':
				return 'Rotina';
			case '/app/filtroquery':
				return 'FiltroPadrao';
			case '/app/ordenacaopadrao':
				return 'OrdenacaoPadrao';
			default:
				return null;
		}
	}

	shouldShowDivider(index: number): boolean {
		// Adiciona divisores após cada 3 itens para criar grupos visuais
		// Você pode personalizar esta lógica conforme sua necessidade
		//return (index + 1) % 5 === 0 && index < this.menus.length - 1;
		return false;
	}
}
